export default "__VITE_PUBLIC_ASSET__0f4f0870__"